const routes = [
  {
    path: 'shadow',
    name: 'shadow',
    component: () => import(/* webpackChunkName: "shadow" */ '@/modules/shadow/index.vue')
  },
];

export default routes;